export class BaseResponseDto {
  responseStatus: BaseResponseStatus;
  responseMessage: string;
  error: any;
  

  constructor(status?: BaseResponseStatus, message?: string) {
    this.responseStatus = status;
    this.responseMessage = message;
  }
}

export class BaseResponseDataDto<T> extends BaseResponseDto {
  data:T;
}

export enum BaseResponseStatus {
  Notice = -2,
  Error = -1,
  Success = 0,
  Unauthorized = 1,
  ValidationError = 2,
  NoAccessToResource = 600,
  NoWritePermission = 610,
  NotAuthorizedSignatory = 620
}
